module.exports = __webpack_public_path__ + "img/testing.aa60947e.svg";